import styled from "styled-components";

export const StyledFooter = styled.footer`
    font-family: 'Poppins', monospace;
    font-size: 0.7rem;
    margin: 1rem;
    width: 80rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
`;